import { render, staticRenderFns } from "./newshop.vue?vue&type=template&id=51f4b9e4"
import script from "./newshop.vue?vue&type=script&lang=js"
export * from "./newshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports